import { getShortTextByKey, renderRichTextByKey } from '$cms/getDataByKey';
import type { CmsContentDictionary } from '$cms/index';

export const getCmsData = (cmsData: CmsContentDictionary) => {
  const getShortText = getShortTextByKey.bind(cmsData);
  const getRichText = renderRichTextByKey.bind(cmsData);

  return {
    toggleText: getShortText('vrmLookup.modal.toggleText', 'Get a quote'),
    ctToggleText: getShortText('vrmLookup.modal.ctToggleText', 'Prendre RDV'),
    modalTitle: getRichText(
      'vrmLookup.modal.title',
      <>
        <p>Get the best price in your</p>
        <p>area for your vehicle</p>
      </>
    ),
    modalCta: getShortText('vrmLookup.modal.cta', 'Get a quote'),
  };
};
